import { Button, Col, Form, Row } from "react-bootstrap";
import { FieldArray, Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { MinusIcon, PlusIcon } from "Assets/icons";
import { useMemo } from "react";
import { array, object } from "yup";
import { urlOptionalSchema, urlRequiredSchema } from "utils/validation/validationHelpers";
import LoadingButton from "components/shared/LoadingButton";

const validationSchema = object().shape({
  shared_doc_links: array().of(urlRequiredSchema).optional()
})

const SharedLinks = ({ data, handleSave }) => {

  const intialValues = useMemo(() => {
    const existingDocs = data?.client_detail?.shared_doc_links;
    return {
      shared_doc_links: existingDocs?.length ? existingDocs : [""]
    }
  }, [data]);

  const handleSubmit = async (values) => {
    try {
      await handleSave(values);
    } catch(err) {
      throw err;
    }
  }

  return (
    
        <Formik
          initialValues={intialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            handleSubmit,
            isSubmitting
          }) => (
            <Form className="align-items-center w-100" onSubmit={handleSubmit}>
              <Row>
                <Col lg="12">
                  <FieldArray name="shared_doc_links">
                    {({ remove, push }) => (
                      <ul className="list-unstyled ps-0 mb-0 w-100">
                        {
                          values.shared_doc_links.map((area, index) => {
                            let isLastItem = index === values.shared_doc_links.length - 1;

                            return (
                              <Row className="mt-2 w-100 align-items-center" key={index}>
                                <Col lg="11">
                                  <div className="w-100 ">
                                    <AppInputField
                                      type="text"
                                      placeholder="Add link to a report"
                                      className="form-control"
                                      name={`shared_doc_links.${index}`}
                                    />
                                  </div>
                                </Col>
                                <Col lg="1 p-0">
                                  <Button
                                    className="border-0 p-0"
                                    variant="transparnet"
                                  >
                                    {isLastItem ? (

                                      values.shared_doc_links.length > 1 ? (
                                        <div className="d-flex">
                                          <PlusIcon onClick={() => push("")} />
                                          <MinusIcon onClick={() => { remove(index) }} />
                                        </div>
                                      ) : <PlusIcon onClick={() => push("")} />

                                    ) : <MinusIcon onClick={() => { remove(index) }} />
                                    }
                                  </Button>
                                </Col>
                              </Row>
                            )
                          })
                        }
                      </ul>
                    )}
                  </FieldArray>
                </Col>
                <Col lg="12 mt-2">
                  <LoadingButton
                    type="submit"
                    style={{
                      height: 40,
                      minWidth: "unset",
                      background: "#071E3E",
                      borderColor: "#071E3E",
                    }}
                    className="d-flex px-3 align-items-center justify-content-center commonBtn"
                    isLoading={isSubmitting}
                  >
                    Save
                  </LoadingButton>
                </Col>
              </Row>

            </Form>
          )}
        </Formik>
  )
}


export default SharedLinks;